import React from 'react';
import PropTypes from 'prop-types';

import useFormContext from 'dpl/shared/form/hooks/useFormContext';
import RadioButtonGroup from 'dpl/form/components/RadioButtonGroup';
import { sendRudderstackEvent } from 'dpl/util/analytics';
import { ANALYTICS_EVENTS } from 'dpl/constants/analytics';

export default function PayNowOrLaterToggle({ analytics }) {
  const { formState, batchSetValue } = useFormContext();

  function handleChange(e) {
    batchSetValue({
      payment_method: 'card',
      pay_now: e.target.value === 'true'
    });

    const cta = e.target.value === 'true' ? 'Pay now' : 'Pay later';
    sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      view: analytics.view,
      view_feature: analytics.viewFeature,
      button_cta: cta,
      checkout_session_id: analytics.checkoutSessionIdRef?.current
    });
  }

  return (
    <div className="PayNowOrLaterToggle mt4">
      <h2 className="lh-title f2 mt8 mb2 font-sans">Choose how to pay</h2>
      <RadioButtonGroup
        name="pay_now"
        variant="tabs"
        value={formState.pay_now}
        onChange={handleChange}
        options={[
          {
            title: 'Pay now',
            subtitle: 'Pay the entire amount today',
            value: true
          },
          {
            title: 'Pay later',
            subtitle: 'Pay over time with Klarna',
            value: false
          }
        ]}
      />
    </div>
  );
}

PayNowOrLaterToggle.propTypes = {
  analytics: PropTypes.shape({
    view: PropTypes.string,
    viewFeature: PropTypes.string,
    checkoutSessionIdRef: PropTypes.shape({
      current: PropTypes.string
    })
  })
};

PayNowOrLaterToggle.defaultProps = {
  analytics: {}
};
